import { XMLBaseParser } from '../../../utils/XMLBaseParser';
import { Logger } from '../../Logger';
import { logConstants } from '../../../utils/Constants';
import { ParserErrorStrings } from '../../AuthErrors';

export interface GatewaySessionResponse {
	GatewaySession: {
		SessionInformation: {
			UrlRewriteRule: string;
			FullVpn: string;
			SecureBrowsePrefix: string;
			LogOff: string;
		};
		CredentialUpdateInformationList: {
			CredentialUpdateInformation: {
				CredentialDisplayName: string;
				PasswordChange: string;
				CredentialUpdateService: string;
			};
		};
	};
}

export interface GatewaySessionResponseJson {
	GatewaySession: {
		SessionInformation: {
			UrlRewriteRule: string;
			FullVpn: string;
			SecureBrowsePrefix: string;
			LogOff: string;
		};
		CredentialUpdateInformationList: {
			CredentialUpdateInformation: {
				CredentialDisplayName: string;
				PasswordChange: string;
				CredentialUpdateService: string;
			};
			xmlns: string;
		};
		xmlns: string;
	};
}
/*
 * GatewaySessionParser parses the response of request to Postback URL
 *	(Sample request URL: https://go.citrix.com/p/u/setClient.do)
 * processParsedXML function is called by the abstract base class method parseXML
 */
export class GatewaySessionParser extends XMLBaseParser<GatewaySessionResponse> {
	private static instance: GatewaySessionParser;

	public static getInstance(): GatewaySessionParser {
		if (!GatewaySessionParser.instance) {
			GatewaySessionParser.instance = new GatewaySessionParser();
		}
		return GatewaySessionParser.instance;
	}

	/**
	 * processParsedXML function is called by the abstract base class method parseXML
	 * @param {GatewaySessionResponseJson} json
	 * @returns GatewaySessionResponse
	 */
	processParsedXML(json: GatewaySessionResponseJson): GatewaySessionResponse {
		try {
			const gatewaySessionResponse: GatewaySessionResponse = {
				GatewaySession: {
					SessionInformation: {
						UrlRewriteRule: json.GatewaySession.SessionInformation?.UrlRewriteRule,
						FullVpn: json.GatewaySession.SessionInformation?.FullVpn,
						SecureBrowsePrefix:
							json.GatewaySession.SessionInformation?.SecureBrowsePrefix,
						LogOff: json.GatewaySession.SessionInformation?.LogOff,
					},
					CredentialUpdateInformationList: {
						CredentialUpdateInformation: {
							CredentialDisplayName:
								json.GatewaySession.CredentialUpdateInformationList
									?.CredentialUpdateInformation?.CredentialDisplayName,
							PasswordChange:
								json.GatewaySession.CredentialUpdateInformationList
									?.CredentialUpdateInformation?.PasswordChange,
							CredentialUpdateService:
								json.GatewaySession.CredentialUpdateInformationList
									?.CredentialUpdateInformation?.CredentialUpdateService,
						},
					},
				},
			};
			return gatewaySessionResponse;
		} catch (e) {
			Logger.getInstance().write(
				logConstants.ERROR,
				ParserErrorStrings.GATEWAY_SESSION_PARSE_ERROR +
					':' +
					JSON.stringify(json) +
					':' +
					e.message
			);
		}
	}
}
